import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import { useNavigate } from "../../hooks/useNavigation";
import { AnalyticsTile } from "../../services/core/types";
import { CountTile } from "./TileRenderers/CountTile";
import { ErrorTile } from "./TileRenderers/ErrorTile";
import { TotalCountTile } from "./TileRenderers/TotalCountTile";
import { ListTile } from "./TileRenderers/ListTile";
import { CaseListTile } from "./TileRenderers/CaseTile";
import { useSearch, useUrl } from "@ofqual/portal-core/core/hooks";

type DashboardTileProps = {
  tile: AnalyticsTile;
};

export const DashboardTile: React.FC<DashboardTileProps> = ({ tile }) => {
  const { location } = useHistory();
  const { searchParams } = useSearch(useUrl());

  let join: string = "" 
  if (searchParams.source !== undefined) {
    if (Array.isArray(searchParams.source)) {
      searchParams.source?.forEach((element: number) => {
        join = join + "&source=" + element;
      });
    }
    else{
      join = "&source=" + searchParams.source;   
    }
  }

  const navigate = useNavigate(location);
  const navigateToFilter = (filterUrl: string) =>
    navigate(`${filterUrl}&DashboardTitle=${tile.title}${join}` );
  return <>{getTileRenderer(tile, navigateToFilter)}</>;
};


const getTileRenderer = (
  tile: AnalyticsTile,
  navigate: (filterUrl: string) => void
): ReactNode => {
  tile.parsedData = JSON.parse(tile.data);
  if (!tile.parsedData || !tile.parsedData.length) {
    return <ErrorTile tile={tile} />;
  }
  switch (tile.type) {
    case "Ofqual.CountTile":
      return <CountTile tile={tile} navigate={navigate} />;

    case "Ofqual.TotalCountTile":
      return <TotalCountTile tile={tile} navigate={navigate} />;

    case "Ofqual.ListTile":
      return <ListTile tile={tile} navigate={navigate} />;
    case "Ofqual.CaseListTile":
      return <CaseListTile tile={tile} navigate={navigate} />;
    default:
      return null;
  }
};
